import { themes } from '@helpers/brand';
import { cssVar } from '@helpers/cssVar';
import { Layers } from '@helpers/layers';
import { Device, from, until } from '@helpers/media';
import { Icon } from '@stories/Components/Buttons/ButtonShared.styles';
import LinkButtonStyles from '@stories/Components/Buttons/LinkButton/LinkButton.styles';
import SiteWide from '@stories/Components/Global/SiteWide/SiteWide';
import styled, { css } from 'styled-components';
const Container = styled.header `
  ${({ themeOption }) => themeOption &&
    css `
      ${themes[themeOption]}
    `}

  position: fixed;
  top: 0;
  left: 0;
  display: grid;
  background: ${cssVar('bgColor')};
  color: ${cssVar('fgColor')};
  height: 174px;
  transform: translateY(-100%);
  transition: background-color 0.3s ease-out, box-shadow 0.3s ease-out, color 0.3s ease-out,
    height 0.3s ease-out, transform 0.3s ease-out;
  width: 100%;
  z-index: ${Layers.Header};

  ${({ transparent }) => transparent &&
    css `
      background: none;
    `}

  ${({ reduced }) => reduced &&
    css `
      background: ${cssVar('bgColor')};
      box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.11);
      color: ${cssVar('fgColor')};
      height: 104px;
    `}

  ${({ visible }) => visible &&
    css `
      transform: translateY(0px);
    `}

  .hamburger-react {
    display: none;
    margin-left: auto;
  }

  @media ${until(Device.Tablet)} {
    height: 78px;

    .hamburger-react {
      display: block;
    }
  }
`;
const Inner = styled(SiteWide) `
  display: flex;
  align-items: center;
`;
const LogoLink = styled.a `
  display: block;
  color: currentColor;

  &:focus {
    outline: auto;
    outline-offset: 5px;
  }
`;
const Logo = styled.span `
  display: block;
  height: 38px;
  margin-right: 16px;
  width: 106px;

  @media ${from(Device.Tablet)} {
    height: 42px;
    width: 120px;
  }

  @media ${from(Device.TabletLarge)} {
    height: 58px;
    width: 166px;
  }
`;
const CtaWrapper = styled.div `
  margin-left: 16px;

  @media ${until(Device.Tablet)} {
    display: none;
  }

  ${LinkButtonStyles.Button} {
    padding-right: 20px;

    ${Icon} {
      transition: transform 200ms ease-out;
    }

    &:hover ${Icon} {
      transform: translateX(8px);
    }

    @media ${until(Device.TabletLarge)} {
      font-size: 18px;
      line-height: 24px;
    }
  }

  @media ${from(Device.TabletLarge)} {
    margin-left: 82px;
  }
`;
const Overlay = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.85);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease-out;
  z-index: 199;

  &[data-active='true'] {
    opacity: 1;
    pointer-events: all;
  }

  @media ${until(Device.Desktop)} {
    display: none;
  }
`;
export default {
    Container,
    CtaWrapper,
    Inner,
    Logo,
    LogoLink,
    Overlay,
};
